import React, { FC, useRef, useState } from 'react';

import { RequiredRule } from 'devextreme-react/data-grid';
import { Item } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { Form, TextBox, ValidationGroup, Validator } from 'devextreme-react';

import { fetchNomenclatureCustomNameCreate } from 'bus/nomenclatureCustomName/actions';

import { useDispatchPromise } from 'hooks/useDispatchPromise';

type CreateNomenclatureProps = {
  nomenclatureId: number | null;
  refresh: () => void;
  visible: boolean;
  changeVisible: (val: boolean) => void;
};

const CreateNomenclatureModal: FC<CreateNomenclatureProps> = ({ nomenclatureId, refresh, changeVisible, visible }) => {
  const dispatch = useDispatchPromise();
  let createValidationRef = useRef<any>(null);
  const [form, setForm] = useState({ name: '' });

  const onHidden = () => refresh();

  const handleSubmit = async () => {
    if (createValidationRef.current?.instance.validate().isValid) {
      await dispatch(fetchNomenclatureCustomNameCreate.async({ ...form, nomenclatureId: nomenclatureId! }));
      changeVisible(false);
      setForm((prev) => ({ ...prev, name: '' }));
      createValidationRef.current?.instance.reset();
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Создать"
        width={400}
        onHidden={onHidden}
        height={'auto'}
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createValidationRef}>
                <Form id="form-name-custom" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Наименование" labelTop>
                          <TextBox
                            stylingMode="underlined"
                            placeholder="Введите наименование"
                            mode="text"
                            value={form.name}
                            onChange={(e: any) => {
                              setForm((prev) => ({ ...prev, name: e.event.currentTarget.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле наименование" />
                            </Validator>
                          </TextBox>
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CreateNomenclatureModal;
